<template>
<div>
  <v-snackbar bottom
              v-model="snackbar"
              :timeout="snackTimeout"
  >
    Ihre Frage wurde erfolgreich hinzugefügt!
  </v-snackbar>
  <v-app-bar
    outlined
    flat
    color="white"
    height="60px"
    absolute
    fixed
    style="border-bottom: 1px solid #EDEDED !important;"
  >
    <IconTooltipButtonBottom
        icon="mdi-arrow-left"
        tooltip="Zurück zur Liste"
        id="default"
        width="50px"
        large
        @click="$router.go(-1)"
    />
    <v-toolbar-title>Fragen manuell hinzufügen</v-toolbar-title>
    <div>
      <v-btn elevation="0" color="primary" :disabled="emptyAnswerOptions || !valid"
             @click="snackbar=true; setTimeout(submitQuestion(), snackTimeout);">Frage
        hinzufügen</v-btn>
    </div>
  </v-app-bar>
  <v-row class="mt-15" style="height: 52vh">
    <v-col :cols="needsAnswerOptions() ? '8':''" class="fill-height pt-12" style="border-right: 1px solid #EDEDED !important;">
      <v-card fluid class="fill-height" flat style="padding: 0 8vw;">
          <v-card-title primary-title class="pa-0">
              <h2 class="ma-0">Einstellungen</h2>
          </v-card-title>
          <v-form v-model="valid" class="pa-0 mt-6">
            <v-row class="mb-3">
              <v-col>
                <v-textarea
                    flat
                    name="input-7-4"
                    clear-icon="mdi-close-circle"
                    label="Fragentext"
                    v-model="questionText"
                    :rules="questionTextRules"
                    value="Fragentext eingeben"
                    rows="1"
                    required
                    @change="updateQuestionPreview()"
                ></v-textarea>
              </v-col>
            </v-row>
              <v-row no-gutters align="center"  class="mb-5">
                  <v-col class="mr-7" style="margin-right:0px !important">
                    <div class="textWithInfo">
                      <v-checkbox
                      v-model="selectedModule"
                      :label="`Prozessperspektiven-Modul`"
                    ></v-checkbox>
                    <div
                          class="infobox-container__icon"
                          @mouseover="showInfobox()"
                          @mouseleave="hideInfobox()">
                        <v-icon color="primary">mdi-information-outline</v-icon>
                    </div>
                    </div>
                    <InfoboxTooltip ref="infoBox"/>
                  </v-col>
                  
                  <v-col class="ml-7" v-if="selectedModule && elementOption.length > 0">
                    <v-select
                        :items="elementOption"
                        v-model="selectedElement"
                        label="Elementtyp"
                        required
                        :rules="elementRules"
                        ></v-select>
                  </v-col>
              </v-row>
              <v-row no-gutters align="center" class="mb-3">
                  <v-col>
                      <v-select
                          :items="answerType"
                          v-model="selectedAnswerType"
                          :rules="selectedAnswerTypeRules"
                          @change="selectAnswerType()"
                          label="Antworttyp"
                          required
                          ></v-select>
                  </v-col>
              </v-row>
          </v-form>
      </v-card>
    </v-col>
    <v-col v-if="needsAnswerOptions()" class="fill-height pa-0">
      <!-- <v-card v-if="needsAnswerOptions() == false" flat
              class="fill-height d-flex flex-column px-12 pt-12" style="opacity: .5;">
        <h2 class="ma-0">Antwortoptionen</h2>
        <div class="svg-container d-flex justify-center mt-12 mb-6">
          <svg width="132" height="114" viewBox="0 0 132 114" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 68.8133C0.000527437 99.8177 57.4995 102.401 92.5 90.2208C119.999 78.0406 132 53.3109 132 28.2125C132 13.8177 118 -10.9119 69.0003 5.32844C30.296 18.1565 -0.000527423 37.8088 0 68.8133Z" fill="#EBEBEB"/>
            <path d="M33.81 105.29L37.88 109.37M84.73 58.4399L43.99 99.1799M81.68 53.3499L89.82 61.4999M87.7884 47.243L95.9343 55.3889L45.0084 106.315L36.8626 98.1688L87.7884 47.243ZM30.75 112.42L36.86 98.1699L45.01 106.31L30.75 112.42ZM94.9571 42.1848L100.982 48.2094C101.569 48.7962 101.569 49.7438 100.982 50.3307L95.9329 55.3794L87.7871 47.2335L92.8358 42.1848C93.4227 41.5979 94.3702 41.5979 94.9571 42.1848Z" stroke="#333333" stroke-width="1.5" stroke-linejoin="round"/>
          </svg>
        </div>
        <p class="px-10 text-center text-gray">
          Antwortoptionen sind abhängig von Antworttyp, der mehrere Wahlmöglichkeiten hat.
        </p>
      </v-card> -->
      <v-card  flat fluid class="fill-height px-8 pt-12 pb-10 overflow-auto scrollable">
        <AnswerOptions :canInvert="checkAnswerType()" :choices="answerOptions"/>
      </v-card>
    </v-col>
  </v-row>

  <v-row>
    <v-col class="pa-0">
        <v-card flat tile color="gray_5" width="100%" height="42vh"
                class="overflow-auto scrollable question-preview">
          <v-card-title style="width: inherit;" class="d-block mb-6 pa-0">
            <h2 class="d-inline ma-0 pa-0">Vorschau</h2>
            <v-btn elevation="0" outlined @click="updateQuestionPreview()" class="float-end" color="secondary">
              <v-icon small>{{ showPreview ? 'mdi-refresh' : 'mdi-eye'}}</v-icon>
              &nbsp;{{ showPreview ? 'Vorschau updaten' : 'Vorschau anzeigen'}}
            </v-btn>
          </v-card-title>
          <v-main style="width: inherit;" class="ma-0 pa-0">
              <v-card v-if="showPreview == false" flat color="gray_5"
                      class="d-flex flex-column justify-center align-center">
                <div class="svg-container mt-12 mb-6">
                  <svg width="132" height="97" viewBox="0 0 132 97" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 68.8133C0.000527437 99.8177 57.4995 102.401 92.5 90.2208C119.999 78.0406 132 53.3109 132 28.2125C132 13.8177 118 -10.9119 69.0003 5.32844C30.296 18.1565 -0.000527423 37.8088 0 68.8133Z" fill="white"/>
                    <path d="M76.69 29.03C76.69 22.8 81.74 17.75 87.97 17.75C94.2 17.75 99.25 22.8 99.25 29.03V67.1M99.25 67.1C99.25 74.8872 92.9372 81.2 85.15 81.2C77.3628 81.2 71.05 74.8872 71.05 67.1C71.05 59.3128 77.3628 53 85.15 53C92.9372 53 99.25 59.3128 99.25 67.1ZM51.31 29.03C51.31 22.8 46.26 17.75 40.03 17.75C33.8 17.75 28.75 22.8 28.75 29.03V67.1M28.75 67.1C28.75 74.8872 35.0628 81.2 42.85 81.2C50.6372 81.2 56.95 74.8872 56.95 67.1C56.95 59.3128 50.6372 53 42.85 53C35.0628 53 28.75 59.3128 28.75 67.1ZM56.95 65.69C56.95 61.8 60.11 58.64 64 58.64C67.89 58.64 71.05 61.8 71.05 65.69M32.98 67.1L40.03 60.05M40.03 68.51L49.19 59.35M38.62 75.56L47.08 67.1M75.28 67.1L80.92 61.46M79.51 68.51L89.38 58.64M93.61 65.69L82.33 76.97" stroke="#6F6F6F" stroke-width="1.5" stroke-miterlimit="10"/>
                  </svg>
                </div>
                <p class="text-gray">
                 Geben Sie einen Fragetext ein und klicken Sie auf Vorschau anzeigen
                </p>
              </v-card>
              <PXSurvey v-if="showPreview" :schema="previewSchema" :displayMode="'display'"
                        class="px-survey-preview"/>
          </v-main>
        </v-card>
    </v-col>
  </v-row>
  </div>
</template>

<script>
import pxQuestionService from './px-question-service'
import pxQuestionGenerator from '@/components/px-survey-generator'
import AnswerOptions from '@/components/common/AnswerTypes/AnswerOptions.vue';
import PXSurvey from '@/components/common/PXSurvey.vue';
import InfoboxTooltip from '../../../components/common/InfoboxTooltip.vue';
import IconTooltipButtonBottom from '../../../components/common/IconTooltipButtonBottom.vue';
import {decodeElementByName} from "@/components/util.js"
export default {
  components: {
    AnswerOptions,
    PXSurvey,
    InfoboxTooltip,
    IconTooltipButtonBottom
},
  data: () => ({
    elementOption:[],
    answerType: [
        {text: 'Datumsauswahl', value: 'DATEPICKER', needsAnswerOptions: false},
        {text: 'Text', value: 'TEXT', needsAnswerOptions: false},
        {text: 'Rating', value: 'RATING', needsAnswerOptions: false},
        {text: 'Kommentar', value: 'COMMENT', needsAnswerOptions: false},
        {text: 'Radiobutton Gruppe', value: 'RADIOGROUP', needsAnswerOptions: true},
        {text: 'Matrixauswahl', value: 'MATRIX', needsAnswerOptions: false},
    ],
    selectedAnswerType: '',
    selectedElement: null,
    selectedModule: '',
    snackbar: false,
    snackTimeout: 3000,
    questionText: '',
    headers: [
        { text: 'Fragentext', value: 'text' },
        { text: 'Fragentyp', value: 'type' },
      ],
    previewSchema: {},
    answerOptions: [{
      value:"",
      inverted: false
    }],
    showPreview: false,
    valid: false,
    questionTextRules: [
      v => !!v || 'Fragentext ist erforderlich',
    ],
    elementRules: [
      v => !!v || 'Elementtyp ist erforderlich',
    ],
    selectedModuleRules: [
      v => !!v || 'Modul ist erforderlich',
    ],
    selectedAnswerTypeRules: [
      v => !!v || 'Antworttyp ist erforderlich',
    ],
  }),
  computed: {
    emptyAnswerOptions() {
      return (this.needsAnswerOptions() && (this.answerOptions.length < 1 ||
          !this.answerOptions[0].value));
    }
  },
  watch:{
    answerOptions(){
      this.updateQuestionPreview();
    },
    selectedModule(){
      if(this.selectedModule){
        pxQuestionService.getElementTypes().then(res => {
          res.data.forEach(elem => {
            this.elementOption.push({
              text: decodeElementByName(elem),
              value: elem
            })
          })
        });
      }else{
        this.elementOption = [];
        this.selectedElement = null;
      }
    }
  },
  mounted() {
  },
  methods: {
    checkAnswerType(){
      return this.selectedAnswerType == 'RADIO';
    },
    updateQuestionPreview(){
      this.showPreview = true;
      this.previewSchema = pxQuestionGenerator.buildQuestionPreview(this.questionText, this.selectedAnswerType, JSON.stringify(this.answerOptions));
    },
    selectAnswerType(){
      this.answerOptions = [{
        value:"",
        inverted: false
      }]
      this.previewSchema = pxQuestionGenerator.buildQuestionPreview(this.questionText, this.selectedAnswerType);
    },
    needsAnswerOptions(){
      let needsAnswer =  this.answerType.find(elem => elem.value == this.selectedAnswerType);
      if(needsAnswer == null) return false;
      return needsAnswer.needsAnswerOptions;
    },
    submitQuestion(){
        let mod = "NONE";
        if(this.selectedModule){
          mod = "Module_Four";
        }
        const question = {
            text: this.questionText,
            type: 'NONE',
            element: this.selectedElement,
            answerType: this.selectedAnswerType,
            module: mod
        }
        
        if(this.answerOptions.length > 0) {
          let options = this.answerOptions.filter(elem => elem.value != "");
          question.answerOptions = JSON.stringify(options)
        }
        pxQuestionService.savePXQuestion(question).then((res) => {
            this.$router.push("/manageQuestions");
        })
    },
    showInfobox() {
        this.$refs['infoBox'].open("Fragen, welche der Prozessperspektive zugeordent werden, beziehen sich auf Elemente innerhalb eines Geschäftsprozesses. Bei sonstigen Fragen, welche sich nicht auf einen Geschäftsprozess beziehen, wird der Button 'Prozessperspektive' nicht ausgewählt.");
      },
    hideInfobox() {
      this.$refs['infoBox'].close();
    },
  },
};
</script>
<style scoped lang="less">
.v-toolbar__title {
  font-size: 18px;
  font-weight: 500;
  color: var(--v-gray-base);
  margin: 0;
}

.v-messages {
  height: 2vh !important;
}

.frame{
    border: 1px solid lightgray;
    margin:5px;
}

.filter{
    width:10%;
    float:right;
    margin-right: 10px;

}
.table-header{
    padding:0 20px !important
}
:deep .v-label {
  margin: 0;
}
.question-preview {
  padding: 6vh 8vw;
  margin: 0;
  overflow-y:scroll;
}
@media screen and (max-width: 768px) {
  .question-preview {
    padding: 6vh 2vw;
  }
}
</style>